import axios from '../request/http';

const order = {
    // 服务订单列表
    serveList(params) {
        return axios.get("/proxy/admin/order/service/list", {params});
    },
    // 商品订单
    productList(params) {
        return axios.get("/proxy/admin/order/goods/list", {params});
    },
    // 订单详情
    orderDetail(params) {
        return axios.get("/proxy/admin/order/detail", {params});
    },
    // 订单分佣明细
    revenueList(params) {
        return axios.get("/proxy/admin/order/revenue/list", {params});
    },
}

export default order;


// WEBPACK FOOTER //
// ./src/api/order.js